import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Unstable_Grid2';
import { Divider, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { TITLE_PAYMENT } from '../../../util/Constants';
import styles from './CheckoutLayoutItem.style';
import useClasses from '../../../hooks/legacy/useClasses';

function CheckoutLayoutItem({
  title,
  subtitle,
  children,
  isLongTitle,
  trackOrders,
}) {
  const { isCheckout } = useSelector(({ order }) => ({
    isCheckout: order.isCheckout,
  }));
  const classes = useClasses(styles);

  return (
    <Grid container columnSpacing={4}>
      <Grid xs={12}>
        <Divider className={classes.divider} />
      </Grid>
      <Grid
        xs={12}
        sm={3}
        mt={trackOrders ? 3 : 0}
        className={[
          title === TITLE_PAYMENT ? classes.titleMargin : classes.titleColor,
          trackOrders ? classes.trackOrderMargin : '',
        ]}
      >
        <Typography
          fontWeight={600}
          fontSize={20}
          className={classes.mainHeading}
        >
          {title}
        </Typography>
        <Typography color="text.secondary" className={classes.subHeading}>
          {(isCheckout || isLongTitle) && subtitle}
        </Typography>
      </Grid>
      <Grid
        xs={12}
        sm={9}
        className={trackOrders ? classes.trackOrderMargin : ''}
      >
        {children}
      </Grid>
    </Grid>
  );
}

CheckoutLayoutItem.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  isLongTitle: PropTypes.bool,
  trackOrders: PropTypes.bool,
};

CheckoutLayoutItem.defaultProps = {
  subtitle: '',
  title: '',
  children: null,
  isLongTitle: false,
  trackOrders: false,
};

export default CheckoutLayoutItem;
